import * as React from 'react'
import styled from 'styled-components'
import Loader from './Loader'

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
  height: 100vh;
  width: 100%;
`

export default () => (<Container><Loader /></Container>)